import React from 'react'
import './css/File.css';
function TestFile() {
  return (
    <div className='File-container'>
        <h3 className='File-h3'>Languages</h3>
        <p className='File-para'>English, Hindi, Punjabi, Urdu and as for the other 3, I can hold a conversation about almost any topic, in those languages; Turkish, Farsi (Persian) & Azerbaijani. There are further 4 languages I understand random bits from; French, Russian, German and Armenian. These 4 languages are the languages I had attempted to study but failed to carry it forward. I am mentioning these languages on my list because sometimes, as what I’ve noticed, even knowing certain words, or as for my French, certain phrases, goes a long way when you are traveling. Certainly I cannot claim I can speak those languages, however, I can communicate better than someone who doesn’t speak or able to read the script at all.
        </p>
    </div>
    
  )
}

export default TestFile